import { emsDarkGrey, emsDarkGreyHover, emsLightGrey } from "@electricMotorShop/EmsVariables";
import { orderTotalDisplayStyles } from "@insite/content-library/Components/OrderTotalDisplay";
import { shareEntityButtonStyles } from "@insite/content-library/Components/ShareEntityButton";
import { twoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import { headerStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { totalStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import { requestRmaButtonsStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaButtons";
import { rfqQuoteDetailsHeaderStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsHeader";
import { rfqQuoteDetailsMessagesStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages";
import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import StarX from "@insite/mobius/Icons/StarX";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// WishListCard
wishListCardStyles.starXIcon = {
    src: StarX,
    size: 15,
    css: css`
        svg path {
            fill: ${getColor("primary.main")};
        }
    `,
};

wishListCardStyles.detailLinkGridItem = {
    width: 12,
    css: css`
        a span {
            font-size: 28px;
            font-weight: bolder;
        }
    `,
};

wishListCardStyles.actionAddToCartButton = {
    color: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
    `, // keep text from wrapping
};

// MyListsCreateListButton
createListButtonStyles.createListButton = {
    color: "primary",
};

// RfqQuoteDetailsMessages
rfqQuoteDetailsMessagesStyles.mainWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        background-color: ${emsLightGrey};
        padding: 10px 20px;
    `,
};

rfqQuoteDetailsMessagesStyles.sendButton = {
    css: css`
        background: ${emsDarkGrey};
        border-color: ${emsDarkGrey};
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            background-color: ${emsDarkGreyHover};
            border-color: ${emsDarkGreyHover};
        }
    `,
};

// RfqQuoteDetailsHeader
rfqQuoteDetailsHeaderStyles.printButton = {
    css: css`
        background: ${emsDarkGrey};
        border-color: ${emsDarkGrey};
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            background-color: ${emsDarkGreyHover};
            border-color: ${emsDarkGreyHover};
        }
    `,
};

// OrderDetailsButtonSet
orderDetailsButtonSetStyles.printButton = {
    css: css`
        background: ${emsDarkGrey};
        border-color: ${emsDarkGrey};
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            background-color: ${emsDarkGreyHover};
            border-color: ${emsDarkGreyHover};
        }
    `,
};

// ShareEntityButton
shareEntityButtonStyles.button = {
    css: css`
        background: ${emsDarkGrey};
        border-color: ${emsDarkGrey};
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            background-color: ${emsDarkGreyHover};
            border-color: ${emsDarkGreyHover};
        }
    `,
};

// OrderTotalDisplay
orderTotalDisplayStyles.container = {
    gap: 10,
    css: css`
        background-color: ${emsLightGrey};
        padding: 20px;
    `,
};

// InvoiceDetailHeader
headerStyles.printButton = {
    css: css`
        margin-left: 10px;
        background: ${emsDarkGrey};
        border-color: ${emsDarkGrey};
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            background-color: ${emsDarkGreyHover};
            border-color: ${emsDarkGreyHover};
        }
    `,
};

// InvoiceDetailsTotal
totalStyles.container = {
    gap: 10,
    css: css`
        background-color: ${emsLightGrey};
        padding: 20px;
    `,
};

// SavedOrderDetailsActionButtons
savedOrderDetailsActionButtonsStyles.addToListButton = {
    css: css`
        margin-left: 10px;
        background: ${emsDarkGrey};
        border-color: ${emsDarkGrey};
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            background-color: ${emsDarkGreyHover};
            border-color: ${emsDarkGreyHover};
        }
    `,
};

savedOrderDetailsActionButtonsStyles.deleteButton = {
    css: css`
    margin-left: 10px;
    background: ${emsDarkGrey};
    border-color: ${emsDarkGrey};
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
        background-color: ${emsDarkGreyHover};
        border-color: ${emsDarkGreyHover};
    `,
};

// RequestRmaButtons
requestRmaButtonsStyles.cancelButton = {
    css: css`
        margin-left: 10px;
        background: ${emsDarkGrey};
        border-color: ${emsDarkGrey};
        &:hover:not(:disabled),
        &:focus:not(:disabled) {
            background-color: ${emsDarkGreyHover};
            border-color: ${emsDarkGreyHover};
        }
    `,
};

// TwoButtonModal
twoButtonModalStyles.submitButton = {
    color: "primary",
};

// AddressBook
addressBookStyles.addressCard = {
    gridContainer: { gap: 20 },
        addressInfoDisplayGridItem: { width: [10, 10, 5, 7, 7] },
        actionsGridItem: {
            width: [2, 2, 7, 5, 5],
            css: css`
                justify-content: flex-end;
            `,
        },
        actionUseAsShippingAddressButton: { variant: "secondary" },
        actionEditLink: {
            css: css`
                display: block;
                margin: 20px auto 0 auto;
            `,
        },
        bottomBorderGridItem: { width: 12 },
        bottomBorder: {
            css: css`
                height: 1px;
                background-color: ${getColor("common.border")};
                width: 100%;
            `,
        },
        overflowMenu: {
            cssOverrides: {
                menu: css`
                    width: 210px;
                `,
            },
        },
};
